document.querySelectorAll('.blog-sidebar-widget .expand-link').forEach((linkElement) => {
   linkElement.addEventListener('click', (clickEvent) => {
      clickEvent.preventDefault();
      const widgetElement = linkElement.closest('.blog-sidebar-widget');
      if (!widgetElement) {
         return;
      }
      const listElement = widgetElement.querySelector('.collapsable-list');
      if (!listElement) {
         return;
      }
      listElement.classList.toggle('list-expanded');
      linkElement.style.display = 'none';
   });
});
